import { DiscIcon } from './DiscIcon';

/**
 * author: Simran
 * id 95CEA0DD-5123-4FFA-B906-E6C55766030D
 * name disc
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/disc.svg
 * tags
 * - Music 
 */
export const CdRomIcon = DiscIcon;
export default CdRomIcon